import React, { useCallback, useEffect } from 'react'
import { btoa } from '@ztechapps/common.utils'
import type { FilterQuery } from '@ztechapps/common.contract'

/**
 * Use this to build the export URL
 * @param url - the default export URL root URL,
 * @param filter - the filter to be passed to controller to filter records retrieval
 * @param name - the operation name, this must be the same by one of the operation from the CsvExportFactory
 * @param accessToken - we use the accessToken to authenticate the user on server, we need to pass it here
 *                  so we can isolate the logic on getting the accessToken
 */
export const useCsvExportUrl = ({
  url = 'reports/csv-export/',
  filter,
  name,
  accessToken,
  encoding,
}: {
  url?: string
  filter?: FilterQuery<any>
  name: string
  accessToken: string
  encoding?: string
}) => {
  const [csvExportUrl, setCsvExportUrl] = React.useState(null)

  const buildExportUrl = useCallback(
    (_filter?: FilterQuery<any>, _name?: string) => {
      const theFilter = _filter ?? filter
      const theName = _name ?? name

      const btoaResult = btoa({ accessToken, filter: theFilter, name: theName, encoding })
      const _url = `${url}/${btoaResult}`

      return _url
    },
    [url, filter, name, accessToken, encoding]
  )

  useEffect(() => {
    const _url = buildExportUrl()
    setCsvExportUrl(_url)
  }, [buildExportUrl])

  return { csvExportUrl, buildExportUrl }
}
